/*
 * File: /src/store/modules/contacts.js
 * Created Date: Wednesday February 27th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:21 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import contactService from 'src/services/contactServices';

const state = {
  contacts: {}, // Hash of promise and expiry
  maxRetries: 5,
};

const getters = {
  getContact: (state) => (id) => {
    return state.contacts[id];
  },
};

const actions = {
  async fetchContact({ commit, getters, dispatch }, contactId) {
    const c = getters.getContact(contactId);
    if (c && c[0] > new Date().getTime()) {
      // return the promise only as its existing
      return c[1];
    }
    // if expired or not existing we get and store a new prom
    // Save the contact promise for future
    // It will resolve all the same
    const prom = contactService
      .fetchContactById(contactId)
      .then((r) => {
        return r.data;
      });
    commit('setContact', {contactId, prom});
    return prom;
  },
  /**
   * Call this on any mutation sent to the backend.
   *  there will be edge cases from this, should someone else
   *  change the contacts name, etc.
   *
   * @param {*} { commit}
   * @param {*} contactId
   */
  deleteContactCache({ commit }, contactId) {
    commit('removeContact', contactId);
  },
};

const mutations = {
  setContact(state, {contactId, prom}) {
    state.contacts[contactId] = [
      new Date().getTime() + 300000, // 5 min
      prom,
    ];
  },
  removeContact(state, contactId) {
    if (state.contacts[contactId]) {
      delete state.contacts[contactId];
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
